import React from 'react';
import { Outlet } from 'react-router-dom';
export function AuthLayout() {
  return <div className="min-h-screen bg-gray-100 flex justify-center w-full" data-id="element-38">
      {/* Mobile Frame Container - No Bottom Nav */}
      <div className="w-full max-w-md bg-brand-background min-h-screen relative shadow-2xl overflow-hidden flex flex-col" data-id="element-39">
        {/* Main Content Area - full height scrollable */}
        <main className="flex-1 overflow-y-auto hide-scrollbar" data-id="element-40">
          <Outlet data-id="element-41" />
        </main>
      </div>
    </div>;
}